import { useMerchant } from "@/hooks/useMerchant";

export function useTopUpsEnabled(): boolean {
  const { merchant } = useMerchant();
  return !!merchant?.payoutsConfig?.skipCreditSettlementsToLedger;
}
